import { ButtonGroup, Drawer, styled } from '@mui/material';
import { rightDrawerWidth } from 'assets/jss/styles';

export const RightSideButtonGroup = styled(ButtonGroup)(({ theme }) => ({
    position: 'absolute',
    right: 0,
    color: 'white',
    transform: 'rotate(-90deg)',
    transformOrigin: '100% 100%',
    marginRight: theme.spacing(-0.5),
    top: theme.spacing(6),
    '& button:not(:first-child)': {
      borderStyle: 'solid',
      borderLeftWidth: '1px',
      borderColor: theme.palette.common.white
    },
    '@media (max-width: 523px)': {
      top: theme.spacing(12)
    },
    '@media (max-width: 1370px)': {
      top: theme.spacing(12)
    }
  }));

  export const RightSideDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
      [theme.breakpoints.up('md')]: {
        width: rightDrawerWidth
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      },
      transitionProperty: 'none'
    }
  }));

  export const RightSideButtonsWrapper = styled('div')(() => ({
    position: 'sticky',
    top: 0,
    zIndex: 10
  }));